import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalBookingComponent } from './external-booking.component';
import { InterfaceFlagModule } from "libraries/component/interface-flag/interface-flag.module";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";

@NgModule({
  declarations: [
    ExternalBookingComponent
  ],
  exports: [
    ExternalBookingComponent
  ],
    imports: [
        CommonModule,
        InterfaceFlagModule,
        HostAliasPipeModule
    ]
})
export class ExternalBookingModule { }
